import React, { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage, useIntl } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { TICKET_SHORTCUT_GTM_ACTIONS } from '@constants/common/gtmEventConstants';

const StyledContainer = styled.div`
    .disabled {
        color: ${({ theme }) => theme.gray5} !important;
        font-weight: normal !important;
    }
`;

//kevin here
export const NavWithReactRouterDomLink = props => {

    const {
        name,
        text,
        icon,
        path,
        visibility,
        iconPrefix = 'fas',
        itemClassName,
        badgeCount = 0,
        showBadgeCount = false,
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <div className="grid-row flex-no-wrap align-items-center">
                        <Link
                            to={path}
                            id={name}
                        >
                            <div className="icon-container">
                                { icon && <FontAwesomeIcon icon={[iconPrefix, icon]} className="icon"/> }
                            </div>
                            <FormattedMessage
                                id = {text}
                            />
                            <ConditionalRendering isTrue={!!badgeCount}>
                                <span className={`unreadRecords-nonInd ${!badgeCount ? 'hide' : ''}`}>{showBadgeCount?badgeCount:1}</span>
                            </ConditionalRendering>
                        </Link>

                    </div>
                </li>
            }
        </Fragment>

    );
};

export const NavWithLinks = ( props ) => {
    
    const {
        name,
        text,
        icon,
        path,
        links,
        visibility,
        replacements,
        cursorNotAllowed = false,
        blank = false,
        iconPrefix = 'fas',
        itemClassName,
        tooltipTextId,
        hotkey
    } = props;

    const intl = useIntl();
    const url = path && replacements && Object.keys(replacements).length > 0 ? path.processReplacements(replacements) : path;
    const link = path && links && links[path] !== null && links[path] !== undefined ? links[path] : url;

    // Keyboard shortcut handler
    useEffect(() => {
        if (!hotkey || cursorNotAllowed) return;
        const handleKeyDown = (e) => {
            const activeElement = document.activeElement;
            const isTextInput = ['INPUT', 'TEXTAREA'].includes(activeElement?.tagName);
            const isContentEditable = activeElement?.isContentEditable;
            const isInsideQuill = document.getElementById('quill-container')?.contains(activeElement);
            if (isTextInput || isContentEditable || isInsideQuill) return;
            if (e.key.toLowerCase() === hotkey.toLowerCase()) {
                e.preventDefault();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'ticket_shortcut_used',
                    shortcut_key: hotkey,
                    shortcut_action: TICKET_SHORTCUT_GTM_ACTIONS[hotkey.toLowerCase()] || name
                });
                if (blank) {
                    window.open(link, '_blank');
                } else {
                    window.location.href = link;
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [hotkey, link, cursorNotAllowed, blank]);

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <StyledContainer className={`grid-row flex-no-wrap ${cursorNotAllowed && 'cursor-not-allowed disabled'}`}>
                        <a
                            href={cursorNotAllowed ? null : link}
                            target={blank ? '_blank' : undefined}
                            id={name}
                            className={`grid-col-auto ${cursorNotAllowed && 'cursor-not-allowed disabled'}`}
                            title={tooltipTextId ? intl.formatMessage({ id: tooltipTextId }) : intl.formatMessage({ id: text })}
                        >
                            <div className="icon-container">
                                {icon && <FontAwesomeIcon icon={[iconPrefix, icon]} className={`grid-col-1 icon ${cursorNotAllowed && 'cursor-not-allowed disabled'}`}/>}
                            </div>
                            <FormattedMessage id={text} />
                        </a>
                    </StyledContainer>
                </li>
            }
        </Fragment>
    );
};

export const NavInputWithButton = ( props ) => {
    const {
        name,
        btnname,
        visibility,
        code,
        onChange,
        onSubmit,
        isDisabled,
        itemClassName
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        'padding-0',
        itemClassName
    );

    return (
        <Fragment key={name}>
            {visibility &&
                <li className = { className } >
                    <form className="usa-form gi-forms">
                        <div className="grid-row flex-no-wrap padding-y-2">
                            <div className="mobile:grid-col-12 tablet:grid-col-fill">
                                <label className="usa-label usa-sr-only" htmlFor={name}>
                                    <FormattedMessage id="sidenav_header_accesscode" />
                                </label>
                                <input
                                    className="grid-col-11 gi-regular_input__input"
                                    id={name}
                                    style={{ height: '40px' }}
                                    data-automation-id={name}
                                    name={name}
                                    btnname={btnname}
                                    type="text"
                                    value={code}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="mobile:grid-col-12 tablet:grid-col-auto">
                                <button onClick={() => onSubmit()}
                                    className="usa-button gi-button gi-button__primary gi-button--small margin-top-0"  style={{ marginTop: '0px' }} data-automation-id={name} disabled={isDisabled}>
                                    <FormattedMessage
                                        id = {btnname}
                                    />
                                </button>
                            </div>
                        </div>
                    </form>
                </li>
            }
        </Fragment>
    );
};

export const NavWithModal = ( props ) => {
    const {
        name,
        text,
        path,
        icon,
        visibility,
        onClick,
        iconPrefix = 'fas',
        itemClassName,
        disabled
    } = props;

    const className = classnames(
        'usa-sidenav__item',
        itemClassName
    );

    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault(); 
            return;
        }
    
        onClick?.(e); 
    };

    return visibility && (
        <Fragment key={name}>
            <li className = { className } >
                <div className="grid-row flex-no-wrap">
                    <a href={ path } onClick={ handleClick } id={ name } data-automation-id={ name } className={`grid-col-auto${disabled ? ' disabled-menu-option' : ''}`}>
                        <div className="icon-container">
                            <FontAwesomeIcon icon={[iconPrefix, icon]} className="grid-col-1 icon"/>
                        </div>
                        <FormattedMessage
                            id = {text}
                        />
                    </a>
                </div>
            </li>
        </Fragment>
    );
};
